import { Vector3, Vector2 } from 'three';

interface ImageMeta<T> {
  center: T;
  size: T;
  shape: T;
}

interface Image<P, T> {
  meta: ImageMeta<T>;
  pixel(i: number): P;
}

export class GrayImage3 implements Image<number, Vector3> {
  meta: ImageMeta<Vector3>;
  data: Float32Array;
  constructor(
    center: Vector3,
    size: Vector3,
    shape: Vector3,
    data: Float32Array
  ) {
    this.meta = { center, size, shape };
    this.data = data;
  }
  pixel(i: number) {
    return this.data[i];
  }
  pixel3(x: number, y: number, z: number): number {
    const result = this.data[
      x * this.meta.shape.y * this.meta.shape.z + y * this.meta.shape.z + z
    ];
    return result;
  }
}

// export class VolumeImage implements Image<number,Vector3>{

// }

export class GrayImage2 implements Image<number, Vector2> {
  meta: ImageMeta<Vector2>;
  data: Float32Array;
  pixel(i: number): number {
    return this.data[i];
  }
  constructor(
    center: Vector2,
    size: Vector2,
    shape: Vector2,
    data: Float32Array
  ) {
    this.meta = { center, size, shape };
    this.data = data;
  }
  min(): number {
    return reduceArrayLike(this.data, Math.min, NaN);
  }
  max(): number {
    return reduceArrayLike(this.data, Math.max, NaN);
  }
}

function reduceArrayLike<T>(
  arr: ArrayLike<T>,
  func: (acc: T, x: T) => T,
  defaultResult: T
) {
  if (arr.length === 0) {
    return defaultResult;
  }
  let result = arr[0];
  for (let i = 1; i < arr.length; i++) {
    result = func(result, arr[i]);
  }
  return result;
}

export interface RGBPixel {
  r: number;
  g: number;
  b: number;
}

export class RGBImage2 implements Image<RGBPixel, Vector2> {
  meta: ImageMeta<Vector2>;
  constructor(
    center: Vector2,
    size: Vector2,
    shape: Vector2,
    public readonly r: Uint8Array,
    public readonly g: Uint8Array,
    public readonly b: Uint8Array
  ) {
    this.meta = { center, size, shape };
    this.r = r;
    this.g = g;
    this.b = b;
  }
  pixel(index: number): RGBPixel {
    return { r: this.r[index], g: this.g[index], b: this.b[index] };
  }
}
